import { Injectable } from '@angular/core';

import { SelectedAccountStore } from '../stores/selected-account-store.service';

@Injectable()
export class AdminUserGuard {
    constructor(private selectedAccountStore: SelectedAccountStore) {}

    canActivate(): boolean {
        return this.selectedAccountStore.selectedAccount.isAdmin();
    }
}
